import { useQuery } from '@tanstack/react-query';
import { getReqUrl, handleDataPlatformError } from '../utils';
import { DROPS_ENDPOINT } from './constants';
import dataPlatformFetch from '../../../utils/dataPlatformFetch';

export const deleteReservation = async (reservationId, correlationId) => {
  const url = getReqUrl(DROPS_ENDPOINT, `/reservation/${reservationId}`);
  await dataPlatformFetch(url, {
    method: 'DELETE',
    correlationId
  });
};

export const useGetReservation = ({
  reservationId,
  recaptchaToken,
  isEnabled = true
}) => {
  const url = getReqUrl(DROPS_ENDPOINT, `/reservation/${reservationId}`);
  return useQuery(
    ['reservation', reservationId],
    async () => {
      const res = await dataPlatformFetch(url, {
        method: 'GET',
        recaptchaToken
      });
      if (!res.ok) {
        await handleDataPlatformError(res);
      }
      return res.json();
    },
    {
      enabled: isEnabled && !!reservationId && !!recaptchaToken,
      cacheTime: 0
    }
  );
};
